import { ref } from "vue";
import brandconfig from "@/brandconfig";

export const LOCALES = {
  en: { title: "English", flag: "GBR" },
  de: { title: "Deutsch", flag: "DEU" },
  nl: { title: "Nederlands", flag: "NLD" },
  es: { title: "Español", flag: "ESP" },
  da: { title: "Dansk", flag: "DNK" },
  it: { title: "Italiano", flag: "ITA" },
  fr: { title: "Français", flag: "FRA" },
  sv: { title: "Svenska", flag: "SWE" },
  pt: { title: "Português", flag: "PRT" },
  zh_Hans: { title: "Chinese (中文)", flag: "CHN" },
  ko: { title: "Korean (한국인)", flag: "KOR" },
  ja: { title: "Japanese (日本語)", flag: "JPN" },
  ar: { title: "Arabic (عربي)", flag: "SAU" },
};

export const locales = ref(null);

export const getLocale = () => {
  if (localStorage.getItem("AcceptLanguage") !== null) {
    return localStorage.AcceptLanguage;
  } else {
    return "en";
  }
};

export const initLocales = () => {
  locales.value = ["en", "nl", "de", "es", "da", "sv", "it", "fr", "pt", "zh_Hans", "ar", "ja", "ko"];
};
